import { z } from 'zod';
import './styles.css';

const root = document.getElementById('root');
if (root === null) throw new Error('Admin root is missing.');
z.config({ jitless: true });
void (async () => {
  const [{ StrictMode }, { createRoot }, { App }] = await Promise.all([
    import('react'),
    import('react-dom/client'),
    import('./App.js'),
  ]);
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
})();
